export const PAGE_TITLE = "Thank You Page & Upsells";
export const LISTING_UUID_SEARCH_KEY = "listing_uuid";
export const COMBO_UUID_SEARCH_KEY = "combo_uuid";

